import { http } from "@/core/api/";

const baseApi = "api/rlvevidence";

export default {
  getHistory(submittedDocumentId) {
    return http.get(`${baseApi}/gethistory/${submittedDocumentId}`);
  },
};
